import React from "react";
import SectionHeader from "../components/SectionHeader";

const AdvisorsSection = ({ data }) => (
    <section className="advisors" id="advisors">

        <div className="container">

            {/* =================================================
                 HEADER
            ================================================== */}

            <SectionHeader
                eyebrow={data.eyebrow}
                title={data.title}
                highlight={data.highlight}
                description={data.description}
            />


            {/* =================================================
                 ADVISORS
            ================================================== */}

            <div className="advisor-grid">

                {(data.items || []).map((item, i) => (

                    <article
                        className="advisor-card"
                        key={item.id || i}
                    >

                        {item.photo && (
                            <div className="advisor-photo">

                                <img
                                    src={item.photo}
                                    alt={item.alt || item.name}
                                />

                            </div>
                        )}

                        <div className="advisor-content">

                            <h3>
                                {item.name}
                            </h3>

                            {item.title && (
                                <p className="advisor-title">
                                    {item.title}
                                </p>
                            )}

                            {item.affiliation && (
                                <p className="advisor-organization">
                                    {item.affiliation}
                                </p>
                            )}

                            {item.country && (
                                <p className="advisor-country">
                                    {item.country}
                                </p>
                            )}

                            {item.bio && (
                                <p className="advisor-bio">
                                    {item.bio}
                                </p>
                            )}

                            {(item.website || item.linkedin) && (
                                <div className="advisor-links">

                                    {item.website && (
                                        <a
                                            href={item.website}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Website
                                        </a>
                                    )}

                                    {item.linkedin && (
                                        <a
                                            href={item.linkedin}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            LinkedIn
                                        </a>
                                    )}

                                </div>
                            )}

                        </div>

                    </article>

                ))}

            </div>

        </div>

    </section>
);

export default AdvisorsSection;